import api from '../../services/api';

const baseUrl = 'crm/pipeline'

const findBySellerId = async (sellerId) =>
    api.get({ service: `${baseUrl}/${sellerId}` });

const findAll = async () =>
    api.get({ service: baseUrl });

export default {
    findBySellerId,
    findAll
}